import createHistory from 'history/createBrowserHistory'

export default createHistory()


// WEBPACK FOOTER //
// ./src/utils/History/history.js